import { NgModule } from '@angular/core';
import { SharedModule } from '@app/shared/shared.module';
import { RichPresenceStateComponent } from '@business/rich-presence/components/rich-presence-state/rich-presence-state.component';
import { RichPresenceBadgeComponent } from './components/rich-presence-badge/rich-presence-badge.component';
import { RichPresenceDeviceAssignedNumbersComponent } from './components/rich-presence-device-assigned-numbers/rich-presence-device-assigned-numbers.component';
import { RichPresenceDeviceNumbersComponent } from './components/rich-presence-device-numbers/rich-presence-device-numbers.component';
import { RichPresenceProfileCardComponent } from './components/rich-presence-profile-card/rich-presence-profile-card.component';
import { RichPresenceProfileDetailsAcdFormComponent } from './components/rich-presence-profile-details-page/rich-presence-profile-details-acd-form.component';
import { RichPresenceProfileDetailsDevicesFormComponent } from './components/rich-presence-profile-details-page/rich-presence-profile-details-devices-form.component';
import { RichPresenceProfileDetailsFeaturesFormComponent } from './components/rich-presence-profile-details-page/rich-presence-profile-details-features-form.component';
import { RichPresenceProfileDetailsPageComponent } from './components/rich-presence-profile-details-page/rich-presence-profile-details-page.component';
import { RichPresenceProfilesPageComponent } from './components/rich-presence-profiles-page/rich-presence-profiles-page.component';
import { SaveToPresenceProfileDialogComponent } from './components/save-to-presence-profile-dialog/save-to-presence-profile-dialog.component';
import { SaveToRichPresenceProfileComponent } from './components/save-to-rich-presence-profile/save-to-rich-presence-profile.component';
import { UpdateRichPresenceProfileComponent } from './components/update-rich-presence-profile/update-rich-presence-profile.component';

@NgModule({
  declarations: [
    RichPresenceStateComponent,
    RichPresenceProfilesPageComponent,
    UpdateRichPresenceProfileComponent,
    RichPresenceBadgeComponent,
    SaveToPresenceProfileDialogComponent,
    SaveToRichPresenceProfileComponent,
    RichPresenceProfileCardComponent,
    RichPresenceProfileDetailsPageComponent,
    RichPresenceProfileDetailsFeaturesFormComponent,
    RichPresenceProfileDetailsDevicesFormComponent,
    RichPresenceProfileDetailsAcdFormComponent,
    RichPresenceDeviceAssignedNumbersComponent,
    RichPresenceDeviceNumbersComponent,
  ],
  exports: [RichPresenceStateComponent, SaveToRichPresenceProfileComponent, RichPresenceBadgeComponent],
  imports: [SharedModule],
})
export class RichPresenceModule {}
